import { useState } from 'react';
import { useAuth } from '../../context/authContext';
import { useNavigate } from 'react-router-dom';
import ImageBox from '../../components/shareable/imageBox';
import { InputArea } from '../../components/shareable/input';
import ClickableText from '../../components/shareable/clickableText';
import FooterNote from '../../components/shareable/footerNote';
import logo from '../../assets/images/image.png';
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login({ email, password });

      if (result.success) {
        // Use redirect path from login result or default to '/home'
        navigate(result.redirect || '/home');
      } else {
        toast.error('Your email or Password is incorrect');
      }
    } catch (err) {
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = () => {
    navigate('/forgot-password'); // You'll need to create this route
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="bg-gray-100 p-8 rounded-lg shadow-md w-full max-w-sm">
        <ImageBox
          src={logo}
          alt="App Logo"
          border={false}
          className="flex justify-center"
        />
        <hr className="my-4 border-gray-400" />

        <form onSubmit={handleLogin} className="space-y-4">
          <InputArea
            type="email"
            placeholder="Input Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <InputArea
            type="password"
            placeholder="Input Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button 
            type="submit"
            disabled={loading}
            className="bg-red-600 text-white px-4 py-2 rounded w-full mt-4"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
          <ClickableText
            text="Forgot Password"
            onClick={handleForgot}
          />
        </form>
      </div>
      <FooterNote text="Bad Ass Band Saws Quoting System v0.01" />
    </div>
  );
};

export default Login;